import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        padding: '56px 0px',
        [theme.breakpoints.down('md')]: {
            padding: '16px 24px 16px 24px',
        },
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1366px',
        background: '#000',
        padding: 40,
        // borderRadius: 12,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            padding: '32px 24px 42px 24px',
        }
    },
    ctnLeft: {
        maxWidth: 380,
        width: '100%',
        '& > img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
        [theme.breakpoints.up('md')]: {
            marginRight: 60
        }
    },
    ctnRight: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        maxWidth: 660,
        [theme.breakpoints.down('sm')]: {
            width: 'auto',
            maxWidth: 480,
            margin: '0 auto',
            alignItems: 'center',
            justifyContent: 'center',
        }
    },
    title: {
        marginTop: 0,
        fontSize: 36,
        color: '#fff',
        fontWeight: 800,
        lineHeight: '40px',
        marginBottom: 16,
        [theme.breakpoints.down('md')]: {
            fontSize: 24,
            lineHeight: '36px',
            marginTop: 24,
            marginBottom: 8
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: 300,
        },
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 500,
        color: '#D1D5DB',
        marginBottom: '28px',
        lineHeight: '32px',
        [theme.breakpoints.down('md')]: {
            fontSize: 18,
            lineHeight: '30px',
            marginTop: 8,
            marginBottom: 24
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center',
        }
    }
}));

export default useStyles;